export let Status;

(function (Status) {
  Status["PendingSync"] = "pendingSync";
  Status["InvoiceSyncFailed"] = "invoiceSyncFailed";
  Status["PaymentSyncFailed"] = "paymentSyncFailed";
  Status["RefundSyncFailed"] = "refundSyncFailed";
  Status["InvoiceRecorded"] = "invoiceRecorded";
  Status["VoidedRecorded"] = "voidedRecorded";
  Status["RefundRecorded"] = "refundRecorded";
  Status["PaymentRecorded"] = "paymentRecorded";
})(Status || (Status = {}));